import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import { COMPANY } from '../data/company';
export function PrivacyPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <div className="min-h-screen bg-[#0a0a0a] pt-20 sm:pt-24" data-id="element-411" data-mp="2s0l35z3ghq5k">
      <section className="page-header" data-id="element-412" data-mp="2s378rt6sdvl5">
        <div className="container mx-auto max-w-6xl px-6 md:px-12" data-id="element-413" data-mp="2x0fw086skpt9">
          <motion.div initial={{
          opacity: 0,
          y: 14
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.26,
          ease: [0.23, 1, 0.32, 1]
        }} className="grid gap-8 lg:grid-cols-[1fr_auto] lg:items-end" data-id="element-414" data-mp="31zach3hae2a7">
            <div className="max-w-3xl" data-id="element-415" data-mp="3fsrycuxg3r3e">
              <p className="eyebrow" data-id="element-416" data-mp="3kqjlzcr24r1s">Información legal</p>
              <h1 className="mt-5 text-4xl font-medium tracking-[-0.055em] text-white sm:text-6xl" data-id="element-417" data-mp="3knxflgfwkhl5">
                Política de Privacidad
              </h1>
            </div>
            <p className="border-l border-white/15 pl-5 text-xs leading-relaxed text-neutral-400 lg:max-w-[185px]" data-id="element-418" data-mp="2yrydhw61z9cx">
              Última actualización:{' '}
              {new Date().toLocaleDateString('es-ES', {
              month: 'long',
              year: 'numeric'
            })}
            </p>
          </motion.div>
        </div>
      </section>

      <section className="section-shell border-b border-white/10" data-id="element-419" data-mp="3hheiowsonpzo">
        <div className="container mx-auto max-w-5xl px-6 md:px-12" data-id="element-420" data-mp="3hipmgwm4oxqs">
          <motion.article initial={{
          opacity: 0,
          y: 12
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.26,
          delay: 0.06,
          ease: [0.23, 1, 0.32, 1]
        }} className="mx-auto max-w-3xl border-x border-t border-white/10" aria-label="Contenido de la política de privacidad" data-id="element-421" data-mp="3dft4n84ex5nw">
            <section className="border-b border-white/10 px-6 py-8 sm:px-10 sm:py-10" data-id="element-422" data-mp="j6b3cllxlels">
              <h2 className="text-xl font-medium tracking-[-0.025em] text-white" data-id="element-423" data-mp="o31lrfl7kmad">
                1. Responsable del tratamiento
              </h2>
              <p className="mt-5 text-sm leading-relaxed text-neutral-300 sm:text-[15px]" data-id="element-424" data-mp="aavfcl7uxto4">
                Growthly Corporation Systems es el responsable del tratamiento
                de los datos
                personales del Usuario y le informa que estos datos serán
                tratados de conformidad con lo dispuesto en el Reglamento (UE)
                2016/679 de 27 de abril de 2016 (GDPR) y la Ley Orgánica 3/2018
                de 5 de diciembre (LOPDGDD).
              </p>
              <ul className="mt-5 space-y-2.5 border-l border-white/15 pl-4 text-sm leading-relaxed text-neutral-300 sm:text-[15px]" data-id="element-425" data-mp="3rmw97tj9nrko">
                <li data-id="element-426" data-mp="1ptyiq4cypb2w">
                  <strong className="font-medium text-white" data-id="element-427" data-mp="1psf0i87qwpyh">Identidad:</strong>{' '}
                  {COMPANY.legalName} (proyecto y servicio en fase de prueba y
                  validación comercial)
                </li>
                <li data-id="element-428" data-mp="36bqkyxy3rfh6">
                  <strong className="font-medium text-white" data-id="element-429" data-mp="3682q9vgx8n0v">Teléfono:</strong>{' '}
                  {COMPANY.phone}
                </li>
                <li data-id="element-430" data-mp="3fabxabczdy9i">
                  <strong className="font-medium text-white" data-id="element-431" data-mp="3f9sj95qgbu0r">
                    Correo electrónico:
                  </strong>{' '}
                  {COMPANY.supportEmail}
                </li>
              </ul>
            </section>

            <section className="border-b border-white/10 px-6 py-8 sm:px-10 sm:py-10" data-id="element-432" data-mp="3p2q1rbvg1izd">
              <h2 className="text-xl font-medium tracking-[-0.025em] text-white" data-id="element-433" data-mp="6so75ectwh3o">
                2. Datos que recogemos
              </h2>
              <p className="mt-5 text-sm leading-relaxed text-neutral-300 sm:text-[15px]" data-id="element-434" data-mp="28llvoxzkonit">
                Recopilamos los datos estrictamente necesarios para el correcto
                desarrollo de nuestra actividad y la prestación de nuestros
                servicios. Estos datos incluyen:
              </p>
              <ul className="mt-5 space-y-3 border-l border-white/15 pl-4 text-sm leading-relaxed text-neutral-400 sm:text-[15px]" data-id="element-435" data-mp="2a2j3p1pvy8y7">
                <li data-id="element-436" data-mp="2f36ubma7cnrw">Datos identificativos: nombre y apellidos.</li>
                <li data-id="element-437" data-mp="2k0ff7umqj5wu">
                  Datos de contacto: dirección de correo electrónico y número de
                  teléfono.
                </li>
                <li data-id="element-438" data-mp="1mbvixfuvfou8">
                  Datos de la solicitud: sector, descripción del proyecto y
                  cualquier información que el usuario decida facilitarnos.
                </li>
                <li data-id="element-439" data-mp="1w9taac8121r2">
                  Datos de pedido y facturación cuando se contrata el servicio.
                  Los datos de pago (tarjeta u otros medios) se introducen y se
                  tratan directamente por el proveedor de pagos y no son
                  almacenados por Growthly Corporation Systems.
                </li>
              </ul>
            </section>

            <section className="border-b border-white/10 px-6 py-8 sm:px-10 sm:py-10" data-id="element-440" data-mp="112ajrud963h7">
              <h2 className="text-xl font-medium tracking-[-0.025em] text-white" data-id="element-441" data-mp="w50tydlybpsu">
                3. Finalidad del tratamiento
              </h2>
              <p className="mt-5 text-sm leading-relaxed text-neutral-300 sm:text-[15px]" data-id="element-442" data-mp="m5jpfzifrhyg">
                Los datos personales proporcionados serán utilizados para las
                siguientes finalidades:
              </p>
              <ul className="mt-5 space-y-3 border-l border-white/15 pl-4 text-sm leading-relaxed text-neutral-400 sm:text-[15px]" data-id="element-443" data-mp="dcy9er66vpdb">
                <li data-id="element-444" data-mp="8emy0c08x6sz">
                  Gestionar la contratación, el pedido y la facturación de
                  nuestros servicios de diseño y desarrollo web.
                </li>
                <li data-id="element-445" data-mp="3uka8fnkxvsqm">
                  Responder a consultas, solicitudes o peticiones realizadas a
                  través de los canales de contacto.
                </li>
                <li data-id="element-446" data-mp="3fy4poz4lpxwo">
                  Enviar comunicaciones comerciales sobre nuestros servicios
                  (solo si se ha dado el consentimiento expreso).
                </li>
                <li data-id="element-447" data-mp="36y7wqlb6icvt">
                  Mejorar la experiencia de usuario en nuestra página web.
                </li>
              </ul>
            </section>

            <section className="border-b border-white/10 px-6 py-8 sm:px-10 sm:py-10" data-id="element-448" data-mp="3bxkrrtc7eq9h">
              <h2 className="text-xl font-medium tracking-[-0.025em] text-white" data-id="element-449" data-mp="3iix3xlo3y5i">
                4. Base legal
              </h2>
              <p className="mt-5 text-sm leading-relaxed text-neutral-300 sm:text-[15px]" data-id="element-450" data-mp="7kxjussgji22">
                La base legal para el tratamiento de sus datos es la ejecución
                de un contrato (en caso de contratación de servicios), el
                consentimiento del interesado (para el envío de comunicaciones
                comerciales y el uso de cookies no técnicas) y el interés
                legítimo (para responder a consultas y mejorar nuestra web).
              </p>
            </section>

            <section className="border-b border-white/10 px-6 py-8 sm:px-10 sm:py-10" data-id="element-451" data-mp="wk0iccwm5hds">
              <h2 className="text-xl font-medium tracking-[-0.025em] text-white" data-id="element-452" data-mp="wi7mlsnjghkk">
                5. Conservación de los datos
              </h2>
              <p className="mt-5 text-sm leading-relaxed text-neutral-300 sm:text-[15px]" data-id="element-453" data-mp="15ddl06khbxd2">
                Los datos se conservarán durante el tiempo necesario para
                cumplir con la finalidad para la que se recabaron y para
                determinar las posibles responsabilidades que se pudieran
                derivar de dicha finalidad y del tratamiento de los datos,
                además de los periodos establecidos en la normativa de archivos
                y documentación.
              </p>
            </section>

            <section className="border-b border-white/10 px-6 py-8 sm:px-10 sm:py-10" data-id="element-454" data-mp="23277oa1avnlw">
              <h2 className="text-xl font-medium tracking-[-0.025em] text-white" data-id="element-455" data-mp="1y0rm8gv7nf2z">
                6. Derechos del usuario
              </h2>
              <p className="mt-5 text-sm leading-relaxed text-neutral-300 sm:text-[15px]" data-id="element-456" data-mp="d5wnwn2ujqc">
                Como usuario, tiene derecho a:
              </p>
              <ul className="mt-5 space-y-3 border-l border-white/15 pl-4 text-sm leading-relaxed text-neutral-400 sm:text-[15px]" data-id="element-457" data-mp="5ayzcfp68vlv">
                <li data-id="element-458" data-mp="f2bvhji067xp">Acceder a sus datos personales.</li>
                <li data-id="element-459" data-mp="f1tp3u1mmdc2">Solicitar la rectificación de los datos inexactos.</li>
                <li data-id="element-460" data-mp="k0n3dooqm8da">
                  Solicitar su supresión cuando, entre otros motivos, los datos
                  ya no sean necesarios para los fines que fueron recogidos.
                </li>
                <li data-id="element-461" data-mp="t2cvkwqg1bc4">Solicitar la limitación del tratamiento de sus datos.</li>
                <li data-id="element-462" data-mp="2pumsptl1qywi">Oponerse al tratamiento de sus datos.</li>
                <li data-id="element-463" data-mp="2pw7plpuu2txj">Solicitar la portabilidad de sus datos.</li>
              </ul>
              <p className="mt-5 text-sm leading-relaxed text-neutral-300 sm:text-[15px]" data-id="element-464" data-mp="2utzpb61pzkca">
                Puede ejercer estos derechos enviando un correo electrónico a{' '}
                {COMPANY.supportEmail}.
              </p>
            </section>

            <section className="px-6 py-8 sm:px-10 sm:py-10" data-id="element-465" data-mp="2djvqjzko85xk">
              <h2 className="text-xl font-medium tracking-[-0.025em] text-white" data-id="element-466" data-mp="2di2kaldyznq3">
                7. Política de Cookies
              </h2>
              <p className="mt-5 text-sm leading-relaxed text-neutral-300 sm:text-[15px]" data-id="element-467" data-mp="369chessn7ero">
                Esta web utiliza únicamente almacenamiento técnico necesario
                para su funcionamiento, incluido el registro local de la
                preferencia de cookies que el usuario selecciona en el aviso
                inicial. Actualmente no cargamos cookies de analítica, de
                perfilado ni de publicidad, ni compartimos datos de navegación
                con terceros con esas finalidades.
              </p>
              <p className="mt-5 text-sm leading-relaxed text-neutral-300 sm:text-[15px]" data-id="element-468" data-mp="1gsbevr454g5i">
                Si en el futuro se incorporan tecnologías no esenciales, sólo se
                activarán tras el consentimiento expreso del usuario, que podrá
                aceptarlas o rechazarlas desde el mismo aviso. El usuario puede
                además configurar su navegador para rechazar o eliminar el
                almacenamiento local en cualquier momento.
              </p>
            </section>
          </motion.article>
        </div>
      </section>
    </div>;
}